import React from 'react'
import {
  PixelFactoryContext,
  PixelFlexBox,
  DcInput,
  PixelText,
  DcButton,
  DcDropDown,
  colors,
  DcFlexBox,
  DcText,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'

import { validateStoreOnboarding } from 'utils/api-routes.util'
import {
  WebsiteDataContainer,
  WebsiteDataTitle,
  WebsiteDataURL,
} from 'app/common/styles/section'
import { IPixelFactory } from '../../../../../decl'

const AddWooCommerceStore = (props) => {
  const { origin } = props
  const { showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    store_name: '',
    protocol: 'https',
    domain: '',
    origin: origin,
  })
  const [error, setError] = React.useState({ field: '', error: '' })
  const [validatedData, setValidatedData] = React.useState({
    auth_url: '',
    favicon: '',
    id: 0,
    title: '',
    url: '',
    validated: false,
  })

  const handleConnectClick = () => {
    window.open(validatedData.auth_url, '_blank')
  }
  const handleSubmit = () => {
    handleValidateStore(data, setValidatedData)
  }

  const handleValidateStore = (data, setValidatedData) => {
    showPageLoader()
    validateStoreOnboarding(data).subscribe((res: AjaxResponse<any>) => {
      hidePageLoader()
      if (res.response.data) {
        localStorage.setItem('lastWooCStore', JSON.stringify(res.response.data))
        setValidatedData(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  return (
    <PixelFlexBox width="100%" height="100%">
      <PixelFlexBox
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        alignContent="stretch"
        gap="20px"
        height="100%"
      >
        <PixelFlexBox
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          alignContent="flex-start"
          height="100%"
        >
          <DcText
            customColor={colors.grayTextDark}
            style={{
              fontSize: '14px',
              lineHeight: 1.5,
              marginBottom: '20px',
              color: '#64748b',
            }}
          >
            Connect your WooCommerce store to seamlessly sync orders, products,
            and manage your operations from one unified PixelOne dashboard.
          </DcText>
          <PixelFlexBox
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            alignContent="flex-start"
            style={{
              borderRadius: '5px',
            }}
            width="100%"
            height="100%"
            padding="10px 0px"
            gap="20px"
          >
            <PixelFlexBox
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              alignContent="flex-start"
              gap="10px"
            >
              <PixelText
                customColor={colors.grayTextDark}
                style={{
                  fontSize: '.875rem',
                  fontWeight: '500',
                  textAlign: 'left',
                }}
              >
                What is the friendly name of your store?
              </PixelText>
              <DcInput
                placeholder="Store Name"
                error={
                  error.field === data.store_name && error.error !== ''
                    ? error.error
                    : null
                }
                value={data.store_name}
                readOnly={validatedData.validated}
                required
                onChange={(e) =>
                  setData({ ...data, store_name: e.target.value })
                }
              />
            </PixelFlexBox>
            <PixelFlexBox
              flexDirection="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              alignContent="flex-start"
              gap="10px"
            >
              <PixelText
                customColor={colors.grayTextDark}
                style={{
                  fontSize: '.875rem',
                  fontWeight: '500',
                  textAlign: 'left',
                }}
              >
                What is the domain of your store?
              </PixelText>
              <PixelFlexBox height="auto" gap="10px">
                <DcFlexBox width="25%" height="auto">
                  <DcDropDown
                    customLabel="Protocol"
                    value={data.protocol}
                    required
                    onChange={(e) =>
                      setData({ ...data, protocol: e.target.value })
                    }
                    options={[
                      { label: 'https://', value: 'https' },
                      { label: 'http://', value: 'http' },
                    ]}
                  />
                </DcFlexBox>
                <DcFlexBox width="75%" height="auto">
                  <DcInput
                    error={
                      error.field === data.domain && error.error !== ''
                        ? error.error
                        : null
                    }
                    value={data.domain}
                    required
                    onChange={(e) =>
                      setData({ ...data, domain: e.target.value })
                    }
                    placeholder="www.myStore.com"
                  />
                </DcFlexBox>
              </PixelFlexBox>
            </PixelFlexBox>
            {validatedData.validated ? (
              <WebsiteDataContainer>
                <PixelText variant="light">
                  {`We're going to send you to your store now to give PixelOne
                  permission to access your data (orders, customers, etc.).
                  <br /> Then the magic happens.`}
                </PixelText>
                <PixelFlexBox
                  flexDirection="column"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  alignContent="flex-start"
                  style={{ padding: '0px' }}
                  height="auto"
                  gap="10px"
                >
                  <PixelFlexBox flexDirection="column" height="auto">
                    <WebsiteDataTitle>{validatedData.title}</WebsiteDataTitle>
                    <WebsiteDataURL>{validatedData.url}</WebsiteDataURL>
                  </PixelFlexBox>
                  <PixelFlexBox
                    gap="10px"
                    height="auto"
                    justifyContent="flex-end"
                  >
                    <DcButton
                      width="50%"
                      variant="secondary"
                      onClick={() => {
                        setValidatedData({
                          ...validatedData,
                          validated: false,
                        })
                      }}
                    >
                      Change
                    </DcButton>
                    <DcButton
                      width="50%"
                      onClick={handleConnectClick}
                      variant="gradient"
                    >
                      Connect
                    </DcButton>
                  </PixelFlexBox>
                </PixelFlexBox>
              </WebsiteDataContainer>
            ) : (
              <PixelFlexBox
                flexDirection="column"
                justifyContent="flex-end"
                alignItems="flex-start"
                alignContent="flex-start"
                gap="10px"
              >
                <DcButton width="25%" variant="gradient" onClick={handleSubmit}>
                  Connect store
                </DcButton>
              </PixelFlexBox>
            )}
          </PixelFlexBox>
        </PixelFlexBox>
      </PixelFlexBox>
    </PixelFlexBox>
  )
}

export default AddWooCommerceStore
